import NotificationsApi from './NotificationsApi';
export default NotificationsApi;